<template>
  <div class="row col-12 pb-3">
    <div class="form-check">
      <input
        :value="value"
        @input="onTerminosPressed"
        type="checkbox"
        class="form-check-input"
        id="terminos-y-condiciones"
      />
      <label class="form-check-label" for="terminos-y-condiciones">
        He leído y acepto los{{" "}}
        <a
          :href="HOME_URL + '/terminosycondiciones.html'"
          target="blank"
        >términos y condiciones</a>
      </label>
    </div>
  </div>
</template>
<script>
import { HOME_URL } from "../../config";
export default {
  props: {
    value: { type: Boolean, required: true },
    onTerminosPressed: { type: Function },
  },
  data() {
    return {
      HOME_URL,
    };
  },
};
</script>